import React, { useState, useEffect } from 'react';
import logo from '../assets/LogoQuickSerc.png';
import { Chart } from 'primereact/chart'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { useHistory } from 'react-router-dom';
import Fechas from '../functions/fechas.functions';
import DashboardController from '../controllers/dashboard.controller';
import NumberFormat from 'react-number-format';
import ChartsFunctions from '../functions/charts.functions';
import ExpansionOrden from '../components/ExpansionOrden';
import LoginController from '../controllers/login.controller';

const Dashboard: React.FC = () => {

    const history = useHistory();
    const [loading, setLoading] = useState<boolean>(true);
    const [datosLogin, setDatosLogin] = useState<any>(undefined);
    const [mostrarError, setMostrarError] = useState<boolean>(false);
    const [fechaInicio, setFechaInicio] = useState<Date>();
    const [fechaFin, setFechaFin] = useState<Date>();
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState<string>(Fechas.Periodos.HOY);
    const [datosConsulta, setDatosConsulta] = useState<any>();
    const [dashboardTarjeta, setDashboardTarjeta] = useState<any>();
    const [dashboardCantidadServicios, setDashboardCantidadServicios] = useState<any>({});
    const [dashboardDensidadServicios, setDashboardDensidadServicios] = useState<any>({});
    const [dashboardDiasSemana, setdashboardDiasSemana] = useState<any>({});
    const [ordenesServicio, setOrdenesServicio] = useState<any>({});
    const [fechaInicialCalendario, setFechaInicialCalendario] = useState<Date>();
    const [fechaFinalCalendario, setFechaFinalCalendario] = useState<Date>();
    const [mostrarMenuUsuario, setMostrarMenuUsuario] = useState<boolean>(false);
    const [ordenAExpandir, setOrdenAExpandir] = useState<any>();

    useEffect(() => {
        try {
            const datosGuardados = localStorage.getItem('data');
            const datosJson = JSON.parse(datosGuardados ? datosGuardados : '');
            const validacion = async () => {
                if (datosGuardados) {
                    //console.log(datosJson);
                    const { usuarioEncontrado, sucursalUsuario } = datosJson;
                    const result = await LoginController.validarEstados(usuarioEncontrado._id, sucursalUsuario._id);
                    if (result.data && result.data.success) {
                        const { estadoUsuario, estadoSuscripcion } = result.data.estados;
                        if (estadoUsuario && estadoSuscripcion) {
                            if (!estadoUsuario.activo || estadoSuscripcion.estado !== 'ACTIVA') {
                                signout();
                            }
                        } else {
                            console.log('NO ESTADOS', result.data)
                        }
                    } else {
                        console.log(result);
                    }
                } else {
                    setMostrarError(true);
                }
            }
            setDatosLogin(datosJson);
            validacion();
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        const { fechaInicio, fechaFin } = Fechas.FechasFunctions.traerFechasPredefinidas(periodoSeleccionado)
        setFechaInicio(fechaInicio);
        setFechaFin(fechaFin);
        if (periodoSeleccionado === Fechas.Periodos.PERSONALIZADO) {
            const fi = new Date();
            const ff = new Date();
            fi.setTime(fechaInicio.getTime());
            ff.setTime(fechaFin.getTime());
            fi.setHours(0);
            fi.setMinutes(0);
            fi.setSeconds(0);
            fi.setMilliseconds(0);
            ff.setHours(23);
            ff.setMinutes(59);
            ff.setSeconds(59);
            ff.setMilliseconds(999);
            setFechaInicialCalendario(fi);
            setFechaFinalCalendario(ff);
        } else {
            setFechaInicialCalendario(undefined);
            setFechaFinalCalendario(undefined);
        }
    }, [periodoSeleccionado]);

    useEffect(() => {
        if (datosLogin && fechaInicio && fechaFin) {
            const idEstablecimiento = datosLogin.establecimiento._id;
            const idSucursal = datosLogin.sucursalUsuario._id;
            DashboardController.tarjetaCantidades(idEstablecimiento, fechaInicio, fechaFin, '')
                .then((res) => {
                    if (res.data && res.data.success) {
                        const { data } = res.data;
                        const {
                            dashboardTarjeta,
                            dashboardCantidadServicios,
                            dashboardDensidadServicios,
                            dashboardDiasSemana,
                            ordenesServicio
                        } = data;
                        setDatosConsulta(data);
                        setDashboardTarjeta(dashboardTarjeta);
                        setDashboardCantidadServicios(ChartsFunctions.generarDatosPieServicios(dashboardCantidadServicios));
                        setDashboardDensidadServicios(ChartsFunctions.generarDatosRadar(dashboardDensidadServicios));
                        setdashboardDiasSemana(ChartsFunctions.generarDatosBarras(dashboardDiasSemana));
                        setOrdenesServicio(ordenesServicio);
                    } else {
                        console.log(res);
                    }
                }).catch(err => {
                    console.log(err);
                })
        }
    }, [fechaInicio, fechaFin])

    const buscarPeriodoPersonalizado = () => {
        if (fechaInicialCalendario && fechaFinalCalendario) {
            const fi = new Date();
            const ff = new Date();
            fi.setTime(fechaInicialCalendario.getTime());
            ff.setTime(fechaFinalCalendario.getTime());
            fi.setHours(0);
            fi.setMinutes(0);
            fi.setSeconds(0);
            fi.setMilliseconds(0);
            ff.setHours(23);
            ff.setMinutes(59);
            ff.setSeconds(59);
            ff.setMilliseconds(999);
            setFechaInicio(fi);
            setFechaFin(ff);
        }
    }

    const valorTabla = (rowData: any) => (
        <NumberFormat value={rowData.valor} displayType={'text'} thousandSeparator={true} prefix={'$'} />
    )

    const fechaTabla = (rowData: any) => {
        const fecha = new Date(rowData.fechaHora);
        return <div>{`${fecha.toLocaleDateString()} ${fecha.toLocaleTimeString()}`}</div>
    }

    const expansionOrden = (data: any) => (
        <ExpansionOrden data={data} key={data._id} />
    )

    const signout = () => {
        localStorage.clear();
        history.push('/Login');
    }

    const contenidoDashboard = () => (
        <div className='p-grid dashboard-content'>
            <Sidebar visible={mostrarMenuUsuario} onHide={() => setMostrarMenuUsuario(false)}>
                <div className='sidebarHeader'>
                    {datosLogin.usuarioEncontrado.nombresApellidos}
                    <br />
                    {datosLogin.establecimiento.nombre}
                </div>
                <Button label='Cerrar Sesión' style={{ marginTop: 10 }}
                    icon='pi pi-sign-out' onClick={signout} />
            </Sidebar>
            <div className="p-col-12" style={{ marginTop: 10 }}>
                <div className="p-grid">
                    <div className="p-col-12 p-md-3 p-lg-3 ">
                        <Button icon="pi pi-user" className="p-button-rounded p-button-info p-button-outlined"
                            style={{ marginRight: 20 }}
                            onClick={() => setMostrarMenuUsuario(true)} />
                        Seleccione el periodo
                    </div>
                    <div className="p-col-12 p-md-3 p-lg-3">
                        <Dropdown optionLabel='nombre'
                            value={periodoSeleccionado}
                            options={Fechas.opcionesPeriodos}
                            optionValue='valor'
                            onChange={(e) => { setPeriodoSeleccionado(e.value) }}
                            style={{ width: '100%' }} />
                    </div>
                    <div className="p-col-12 p-md-3 p-lg-3">
                        Fecha Inicial:
                        {
                            periodoSeleccionado !== Fechas.Periodos.PERSONALIZADO ?
                                ' ' + fechaInicio?.toLocaleDateString()
                                :
                                <div className="p-grid">
                                    <div className="p-col-10">
                                        <Calendar locale={Fechas.es} dateFormat="dd/mm/yy"
                                            value={fechaInicialCalendario}
                                            onChange={(e: any) => setFechaInicialCalendario(e.value)}
                                            maxDate={fechaFinalCalendario} />
                                    </div>
                                </div>
                        }
                    </div>
                    <div className="p-col-12 p-md-3 p-lg-3">
                        Fecha final:
                        {
                            periodoSeleccionado !== Fechas.Periodos.PERSONALIZADO ?
                                ' ' + fechaFin?.toLocaleDateString()
                                :
                                <div className="p-grid">
                                    <div className="p-col-10">
                                        <Calendar locale={Fechas.es} dateFormat="dd/mm/yy"
                                            value={fechaFinalCalendario}
                                            onChange={(e: any) => setFechaFinalCalendario(e.value)}
                                            maxDate={new Date()} minDate={fechaInicialCalendario} />
                                    </div>
                                    <div className="p-col-2">
                                        <Button icon="pi pi-search"
                                            className="p-button-rounded p-button-outlined"
                                            onClick={buscarPeriodoPersonalizado} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="p-col-12 p-lg-4">
                <div className="dashboard-cantidad-ordenes">
                    <h2>Órdenes</h2>
                    <p>{dashboardTarjeta ? dashboardTarjeta.cantidad : ''}</p>
                </div>
                <div className="dashboard-cantidad-ordenes">
                    <h2>Ventas</h2>
                    <p>
                        <NumberFormat value={dashboardTarjeta ? dashboardTarjeta.ventas : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    </p>
                </div>
                <div className="dashboard-cantidad-ordenes">
                    <h2>Servicios</h2>
                    <p>{dashboardTarjeta ? dashboardTarjeta.servicios : ''}</p>
                </div>
            </div>
            <div className="p-col-12 p-lg-8">
                Cantidad de servicios
                     <Chart type='doughnut' data={dashboardCantidadServicios} />
            </div>
            <div className="p-col-12 p-lg-8" >
                Densidad de servicios por tipo de vehículo
                    <Chart type="radar" data={dashboardDensidadServicios} />
            </div>
            <div className="p-col-12 p-lg-4" >
                Cantidad de servicios por día
                    <Chart type="horizontalBar" data={dashboardDiasSemana} height='300' />
            </div>
            {
                datosConsulta ?
                    <div className="p-col-12">
                        <DataTable value={ordenesServicio} className='dataTableOrdenes'
                            header='Listado de órdenes registradas' paginator={true}
                            rows={10} expandedRows={ordenAExpandir} dataKey='_id'
                            onRowToggle={(e: any) => setOrdenAExpandir(e.data)}
                            rowExpansionTemplate={expansionOrden} >
                            <Column expander style={{ width: '3em' }} />
                            <Column field="fechaHora" header="Fecha y hora" filter={true}
                                sortable={true} body={fechaTabla} />
                            <Column field="usuarioRegistra.nombresApellidos" header="Usuario que registró" filter={true}
                                sortable={true} />
                            <Column field="vehiculo.placa" header="Placa" filter={true}
                                sortable={true} />
                            <Column field="valor" header="Valor" filter={true}
                                sortable={true} body={valorTabla} />
                            <Column field="estadoActual.nombre" header="Estado" filter={true}
                                sortable={true} />
                        </DataTable>
                    </div>
                    : null
            }
        </div>
    )

    return <>
        <div>
            <div className='dashboard-header'>
                <img src={logo} alt='Quickserk' className='dashboard-logo' />
            </div>
            <Dialog visible={loading} style={{ width: '50vw' }}
                onHide={() => setLoading(false)}
                closable={false}
                closeOnEscape={false}
                contentStyle={{ textAlign: 'center' }}>
                <ProgressSpinner />
            </Dialog>
            {
                mostrarError ?
                    <div style={{ marginTop: 150, marginLeft: 10 }}>
                        <h1>Error: Debe acceder por <a href='/'>login</a></h1>
                    </div>
                    :
                    datosLogin ?
                        contenidoDashboard()
                        : null
            }
        </div>
    </>
}

export default Dashboard;